import { merge, isObject } from 'lodash';

/**
 * The location/warehouse model
 */
export class BaseTransactionLocationModel {
  id: string;
  city: string;
  houseno: string;
  houseadd: string;
  name: string;
  street: string;
  zipcode: string;
  phone: string;
  email: string;
  website: string;
  bankAccountNumber: string;
}

/**
 * The cashier model
 */
export class BaseTransactionCashierModel {
  id: string;
  name: string;
  fullname: string;
}

/**
 * A sku item
 */
export class BaseTransactionSkuModel {
  category: string;
  qty: number;
  group: string;

  reqid?: string;

  /**
   * The actual price that an item was sold for.
   */
  price: number;

  /**
   * The original price of an individual item.
   */
  nettPrice: number;

  /**
   * Total paid for the elements on the line
   */
  lineTotal: number;

  articleCode: string;
  articleDescription: string;
  barcode: string;
  brand: string;
  changeDisc: boolean;
  color: string;
  found: boolean;
  sizeLabel: string;
  vat: number;

  couponNr: string;

  // coupon specific
  type: string;
  value?: number;
  couponBalance?: number;

  // not documented in spynl.app, but used in sales-calculations
  discount: number;
  linePrice: number;
  lineType: string;
  showDiscount: boolean;
  total: number | string;
}

type PartialBaseTransactionModel = Partial<
  Omit<BaseTransactionModel, 'shop' | 'cashier'>
> & {
  cashier: Partial<BaseTransactionCashierModel>;
  shop: Partial<BaseTransactionLocationModel>;
};

/**
 * TODO document the class
 */
export class BaseTransactionModel {
  _id: string;
  active: boolean;
  buffer_id: string;
  cashier: BaseTransactionCashierModel;
  device_id: string;
  device: string;

  /**
   * The unique identifier of the sale. This can be the webshop order id, or if not provided it defaults to a UUID v4.
   */
  nr: string;

  printed: string;
  receipt: BaseTransactionSkuModel[];
  receiptNr: number;
  remark: string;
  shift: string;
  shop: BaseTransactionLocationModel;
  tenant_id: string[];
  type: number | 'withdrawal';

  constructor(originalValue?: PartialBaseTransactionModel) {
    merge(this, originalValue);
  }

  /**
   * Checks model validity
   */
  isValid(): Boolean {
    if (!isObject(this.cashier) || !isObject(this.shop)) {
      return false;
    }
    return true;
  }
}

// Hack! It makes sure that in the test scripts & test are using the same
// reference to the class
export const BaseTransactionModelProvider = {
  provide: 'BaseTransactionModel',
  useValue: BaseTransactionModel,
};
